import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=7a055cfc&scoped=true"
import script from "./SidebarLayout.vue?vue&type=script&lang=js"
export * from "./SidebarLayout.vue?vue&type=script&lang=js"
import style0 from "./SidebarLayout.vue?vue&type=style&index=0&id=7a055cfc&prod&lang=scss&scoped=true"
import style1 from "./SidebarLayout.vue?vue&type=style&index=1&id=7a055cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a055cfc",
  null
  
)

export default component.exports